import React from "react";
import { Icon } from "./Icon";

export function Select({ options = [], invalid = false, disabled = false, style = {}, ...rest }) {
  const [focus, setFocus] = React.useState(false);
  return (
    <div style={{ position: "relative", width: "100%" }}>
      <select
        disabled={disabled}
        onFocus={() => setFocus(true)}
        onBlur={() => setFocus(false)}
        style={{
          width: "100%", padding: "11px 40px 11px 16px", appearance: "none",
          fontFamily: "var(--font-body)", fontSize: "var(--text-base)",
          color: "var(--text-body)", background: disabled ? "var(--surface-muted)" : "var(--surface-raised)",
          border: `1.5px solid ${invalid ? "var(--danger)" : focus ? "var(--hive)" : "var(--border-default)"}`,
          borderRadius: "var(--radius-sm)", outline: "none", cursor: "pointer",
          boxShadow: focus ? "var(--shadow-focus-input)" : "none",
          transition: "border-color var(--duration-fast) var(--ease-out), box-shadow var(--duration-fast) var(--ease-out)",
          ...style,
        }}
        {...rest}
      >
        {options.map((o) => (
          <option key={o.value} value={o.value}>{o.label}</option>
        ))}
      </select>
      <Icon name="chevron-down" size={16} style={{
        position: "absolute", right: 14, top: "50%", transform: "translateY(-50%)",
        color: "var(--text-muted)", pointerEvents: "none",
      }} />
    </div>
  );
}
